/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { method, render } from '../lib';
import { VmDailymotion, VmEmbed } from '@vime/core';
import { define } from '../lib';
define('vm-dailymotion', VmDailymotion);
define('vm-embed', VmEmbed);
export default Vue.extend({
    props: {
        videoId: {},
        shouldAutoplayQueue: {},
        showUpNextQueue: {},
        showShareButtons: {},
        color: {},
        syndication: {},
        showDailymotionLogo: {},
        showVideoInfo: {},
        language: {},
        autoplay: {},
        controls: {},
        poster: {},
        logger: {},
        loop: {},
        muted: {},
        playsinline: {},
    },
    methods: {
        getAdapter: method('getAdapter'),
    },
    render: render('vm-dailymotion', ['vmLoadStart', 'vmError']),
});
//# sourceMappingURL=Dailymotion.js.map